export const appids : any = {
  'usdc/usd': 70116074,
  'trx/usd': 70116100,
  'luna/usd': 70116122,
  'usdt/usd': 70116137,
  'eth/usd': 70116155,
  'atom/usd': 70116176,
  'busd/usd': 70116213,
  'shib/usd': 70116257,
  'algo/usd': 53083112,
  'avax/usd': 70116312,
  'leo/usd': 70116331,
  'sol/usd': 70116350,
  'near/usd': 70116376,
  'ust/usd': 70116391,
  'dot/usd': 70116407,
  'ceth/usd': 70116428,
  'ltc/usd': 70116445,
  'klay/usd': 70116470,
  'wbtc/usd': 70116491,
  'uniswap/usd': 70116518,
  'mim/usd': 70116529,
  'okb/usd': 70116548,
  'ftm/usd': 70116560,
  'vet/usd': 70116578,
  'xlm/usd': 70116594,
  'hnt/usd': 70116612,
  'ada/usd': 70116648,
  'bch/usd': 70116676,
  'hbar/usd': 70116691,
  'icp/usd': 70116703,
  'theta/usd': 70116752,
  'fil/usd': 70116779,
  'cro/usd': 70116795,
  'axs/usd': 70116813,
  'matic/usd': 70116865,
  'bnb/usd': 70116889,
  'xtz/usd': 70116927,
  'etc/usd': 70116957,
  'one/usd': 70116973,
  'sand/usd': 70117008,
  'btc/usd': 70117029,
  'dai/usd': 70117042,
  'mana/usd': 70117059,
  'egld/usd': 70117085,
  'xmr/usd': 70117130,
  'xpr/usd': 70117161,
  'ftt/usd': 70117180,
  'steth/usd': 70117217,
  'doge/usd': 70117237,
  'link/usd': 70117257
}